module.exports = __webpack_public_path__ + "img/gwrraSeal@2x.88e12c84.webp";